export default function isFeatureEnabled(key) {
  const params = new URLSearchParams(window.location.search);
  if (params.get('features')?.includes(key)) {
    return true;
  }
  if (process.env['REACT_APP_FEATURE_FLAGS']?.includes(`${key}=1`)) {
    return true;
  }
  return false;
}
